export class ResetPassword {
    public password;
    public passwordConfirmation;
}